import { Button } from '@boltenergy-be/design-system'
import { useStoreDispatch } from 'hooks/store'
import { switchLanguage } from 'store/app/thunks'
import styles from './LanguageSwitchButton.module.scss'
import { useTranslation } from 'react-i18next'
import { LANGUAGES } from '@boltenergy-be/shared'

const LanguageSwitchButton = ({ withIcon = true }: { withIcon?: boolean }) => {
  // Redux store
  const dispatch = useStoreDispatch()

  // i18n
  const { i18n } = useTranslation()

  /**
   * Handles the switch language action
   */
  const handleSwitchLanguage = () => {
    void dispatch(
      switchLanguage({
        language: i18n.language.toUpperCase() === LANGUAGES.NL ? LANGUAGES.FR : LANGUAGES.NL
      })
    )
  }
  return (
    <Button variant="tertiary" leadingIcon={withIcon ? 'globe' : undefined} onClick={handleSwitchLanguage} className={styles['lang-btn']}>
      {i18n.language.toUpperCase()}
    </Button>
  )
}

export default LanguageSwitchButton
